/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class ReviewsAssignedReviewIssueRoute extends Route {
  analytics = {
    section: 'inbox',
    place: 'reviews.assigned.review.issue',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(ReviewsAssignedReviewIssueRoute);
